const environment = {
  //   PUSHER_APP_ID: "1931043",
  //   PUSHER_APP_KEY: "3a80662dd5ee369e0b83",
  //   PUSHER_APP_SECRET: "b9b119a720ab66daa37a",
  //   PUSHER_CLUSTER: "us2",

  PUSHER_APP_ID: "1931089",
  PUSHER_APP_KEY: "2e603f5ea3523f08e7b",
  PUSHER_APP_SECRET: "553ec904333f214a759e",
  PUSHER_CLUSTER: "ap2",
};

export default environment;
